import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import '../../../../node_modules/lit-media-query/lit-media-query.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeSVG as o } from '../../../../node_modules/lit-html/directives/unsafe-svg.js';
import { ifDefined as l } from '../../../../node_modules/lit-html/directives/if-defined.js';
import { triggerExternalLinkPopup } from '../../utilities/behavior-helpers/index.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './main-categories-item.scss.js';

const arrowIcon = `<svg aria-hidden="true" focusable="false" width="16" height="30" viewBox="0 0 16 30" fill="none" xmlns="http://www.w3.org/2000/svg">
	<line x1="2" y1="-2" x2="18.1004" y2="-2" transform="matrix(0.682661 -0.730736 0.682661 0.730736 2.00006 29.5879)" stroke="currentColor" stroke-width="4" stroke-linecap="round"></line>
	<line x1="2" y1="-2" x2="18.1004" y2="-2" transform="matrix(-0.682661 -0.730736 0.682661 -0.730736 15.7218 14.8999)" stroke="currentColor" stroke-width="4" stroke-linecap="round"></line>
</svg>`;
class MainCategoriesItem extends s {
    constructor() {
        super(...arguments);
        this.query = '(max-width: 1365px)';
        this.isDesktop = false;
        this.externalLinkPopup = null;
    }
    handleMediaQuery(event) {
        this.isDesktop = !event.detail.value;
    }
    renderCTA() {
        return this.ctaText && this.href
            ? x `<a @click="${(e) => triggerExternalLinkPopup(e, this)}" @keyup="${(e) => triggerExternalLinkPopup(e, this)}" class="cta" href="${l(this.href)}">${this.ctaText} <span class="cta-icon">${o(arrowIcon)}</span></a>`
            : null;
    }
    firstUpdated() {
        var _a;
        const item = this.shadowRoot.querySelector('.item');
        if (this.classList.contains('divider'))
            item === null || item === void 0 ? void 0 : item.classList.add('divider', `item-${this.getAttribute('index')}`);
        (_a = document.querySelector('.fallback-link')) === null || _a === void 0 ? void 0 : _a.remove();
        const modal = document.querySelector('cvt-modal[popupid="external-link"]');
        if (!modal)
            return;
        this.externalLinkPopup = modal.querySelector('external-link');
    }
    render() {
        return x `<article aria-labelledby="${l(this.titleId)}" class="item ${this.href ? '' : 'no-href'} ${this.rtl || isRTL() ? 'rtl' : ''}"><div class="image-wrapper ${this.isWide ? 'wide' : ''}"><slot name="image"></slot></div><div class="text-content"><slot name="title"></slot><slot name="text" class="body"></slot>${this.renderCTA()}</div></article><lit-media-query .query="${this.query}" @changed="${this.handleMediaQuery}"></lit-media-query>`;
    }
}
MainCategoriesItem.styles = css_248z;
__decorate([
    n({ type: Boolean })
], MainCategoriesItem.prototype, "rtl", void 0);
__decorate([
    n({ type: Boolean })
], MainCategoriesItem.prototype, "isWide", void 0);
__decorate([
    n({ type: String })
], MainCategoriesItem.prototype, "href", void 0);
__decorate([
    n({ type: String })
], MainCategoriesItem.prototype, "ctaText", void 0);
__decorate([
    n({ type: String })
], MainCategoriesItem.prototype, "titleId", void 0);
__decorate([
    t()
], MainCategoriesItem.prototype, "isDesktop", void 0);
__decorate([
    t()
], MainCategoriesItem.prototype, "externalLinkPopup", void 0);
customElements.define('main-categories-item', MainCategoriesItem);

export { MainCategoriesItem };
